export default __webpack_public_path__ + "static/media/portfolio-hover-173.1d8a0aee.jpg";